import { render, staticRenderFns } from "./NotificationSource.vue?vue&type=template&id=f9028e6c&"
import script from "./NotificationSource.vue?vue&type=script&lang=ts&"
export * from "./NotificationSource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports